var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.colorful)?_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":'#icon-' + _vm.type}})]):_c('i',{class:['iconfont', 'icon-' + _vm.type]})}
var staticRenderFns = []

export { render, staticRenderFns }